import React from "react";
import { useIntl } from "react-intl";
import { UserLoggedInNavigatorScreenProps } from "../../TopLevelNavigators/UserLoggedIn/UserLoggedInNavigatorParamList";
import { ProfileScreen } from "./ProfileScreen";
import { ProfileStack } from "./ProfileStack";
import { EditNameScreen } from "./EditName";
import { UserSetStoreScreen } from "./UserSetStoreScreen";
import { ProfileCreateStoreScreen } from "./ProfileCreateStoreScreen";
import { withWebModal } from "@/src/TopLevelNavigators/UserLoggedIn/withWebModal";

import { useProfileScreenNavigationHeaderOptions } from "./useProfileScreenNavigationHeaderOptions";
import { useNavigationHeaderOptions } from "@/src/common/navigationHeaderOptions";
import { useIntlTokens } from "@/src/components/mobile/useIntlTokens";
export const ProfileNavigator = withWebModal(ProfileNavigatorC, true);
function ProfileNavigatorC(props: UserLoggedInNavigatorScreenProps<"Profile">) {
  const intl = useIntl();
  const intl_tokens = useIntlTokens();

  const profileNavHeaderOptions = useProfileScreenNavigationHeaderOptions({});
  const getHeaderOptions = useNavigationHeaderOptions();
  return (
    <>
      <ProfileStack.Navigator>
        <ProfileStack.Screen
          name="ProfileMain"
          component={ProfileScreen}
          options={profileNavHeaderOptions}
        />
        <ProfileStack.Screen name="EditName" component={EditNameScreen} />
        <ProfileStack.Screen
          name="SetStore"
          component={UserSetStoreScreen}
          options={({ navigation }) =>
            getHeaderOptions({
              type: "SAVE-INIT",
              onCancel: () => navigation.goBack(),
              title: intl_tokens.SelectStore,
            })
          }
        />
        <ProfileStack.Screen
          name="CreateStore"
          component={ProfileCreateStoreScreen}
          options={{
            headerTitle: intl.formatMessage({
              defaultMessage: "Create new Store",
              description: "UserProfile:CreateStoreScreen: header title",
            }),
          }}
        />
      </ProfileStack.Navigator>
    </>
  );
}
